// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/Others/Background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --login-content-height: 85%;
    --login-content-border-radius: 12px;
}
 
.login-page-starter-section {
    width: 100%;
    height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: fixed;
    max-height: -webkit-fill-available;
    z-index: -1;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
}

 
.wrapper-login-page-section {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    scroll-behavior: smooth;
    overflow-y: scroll;
    max-height: -webkit-fill-available;
}
 
.login-page-content-section {
    width: 100%;
    height: var(--login-content-height);
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 30px #08255C;
    border-radius: var(--login-content-border-radius);
    display: flex;
    align-items: center;
    z-index: 1;
    max-height: -webkit-fill-available;
}
 
/* .login-page-content-section>div:first-child {
    height: 100%;
} */
 
/* .login-page-content-section>div:first-child>img {
    border-radius: 12px 0 0 12px;
    height: 100%;
    width: 100%;
    opacity: 1;
} */
 
.login-page-content-section>div:nth-child(2) {
    /* padding-right: 47px !important; */
    min-height: 322px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
 
.login-page-main-content-section {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
 
.login-page-main-content-section>div:nth-child(2) {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0px;
    color: #666666;
}
 
.login-page-main-content-section>div:nth-child(3) {
    font: normal normal normal 26px/30px Lato;
    letter-spacing: 0px;
    margin-bottom: 20px;
    color: #333333;
}
 
.login-page-btn {
    min-height: 56px;
}
 
 
.login-page-msg-under-line {
    height: 4px;
    width: 10%;
    background: #FF9700 0% 0% no-repeat padding-box;
    border-radius: 6px;
}
 
.footer-start-section-login{
    position: absolute !important;
    top: 100% !important;
}
 
@media screen and (max-width:992px) {
    :root {
        --login-content-height: 100%;
        --login-content-border-radius: 0;
    }
 
    .login-page-starter-section {
        width: 100%;
        height: 100vh;
        background-color: var(--bg-blue);
        overflow: hidden;
        position: fixed;
        z-index: -1;
    }
    .login-page-content-section {
        max-width: 100%;
        flex: 100% 1;
    }
 
    /* .login-page-content-section>div:first-child {
        display: none;
    } */
 
    /* .login-page-content-section>.col-md-6:first-child {
        max-width: 0;
        flex: 0;
    } */
 
    .login-page-content-section>div:nth-child(1) {
        padding-right: 0 !important;
        min-height: 100vh;
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
    }
 
    .login-page-main-content-section {
        min-height: 100vh;
        justify-content: center;
    }
 
    .login-page-main-content-section>div:nth-child(3) {
        font: normal normal normal 26px/30px Lato;
        text-align: center;
        padding: 0 7px;
        font: normal normal bold 26px/32px Lato;
    }
 
    .login-page-main-content-section .login-page-logo {
        /* position: absolute; */
        top: 10px;
    }
 
    .login-page-main-content-section .celcom-default-btn.login-page-btn {
     /* position: absolute;  */
        bottom: 50px;
        max-width: 50%;
        margin-top: 50px;
        min-height:50px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yDAAwD;IACxD,eAAe;IACf,kCAAkC;IAClC,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,6DAA6D;IAC7D,gCAAgC;IAChC,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kCAAkC;AACtC;;AAEA;;GAEG;;AAEH;;;;;GAKG;;AAEH;IACI,oCAAoC;IACpC,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,UAAU;IACV,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI;QACI,4BAA4B;QAC5B,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gCAAgC;QAChC,gBAAgB;QAChB,eAAe;QACf,WAAW;IACf;IACA;QACI,eAAe;QACf,YAAU;IACd;;IAEA;;OAEG;;IAEH;;;OAGG;;IAEH;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,WAAW;QACX,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,yCAAyC;QACzC,kBAAkB;QAClB,cAAc;QACd,uCAAuC;IAC3C;;IAEA;QACI,wBAAwB;QACxB,SAAS;IACb;;IAEA;KACC,yBAAyB;QACtB,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[":root {\r\n    --login-content-height: 85%;\r\n    --login-content-border-radius: 12px;\r\n}\r\n \r\n.login-page-starter-section {\r\n    width: 100%;\r\n    height: 100vh;\r\n    background-image: url(\"../Images/Others/Background.jpg\");\r\n    position: fixed;\r\n    max-height: -webkit-fill-available;\r\n    z-index: -1;\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-attachment: fixed;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n \r\n.wrapper-login-page-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    scroll-behavior: smooth;\r\n    overflow-y: scroll;\r\n    max-height: -webkit-fill-available;\r\n}\r\n \r\n.login-page-content-section {\r\n    width: 100%;\r\n    height: var(--login-content-height);\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 30px #08255C;\r\n    border-radius: var(--login-content-border-radius);\r\n    display: flex;\r\n    align-items: center;\r\n    z-index: 1;\r\n    max-height: -webkit-fill-available;\r\n}\r\n \r\n/* .login-page-content-section>div:first-child {\r\n    height: 100%;\r\n} */\r\n \r\n/* .login-page-content-section>div:first-child>img {\r\n    border-radius: 12px 0 0 12px;\r\n    height: 100%;\r\n    width: 100%;\r\n    opacity: 1;\r\n} */\r\n \r\n.login-page-content-section>div:nth-child(2) {\r\n    /* padding-right: 47px !important; */\r\n    min-height: 322px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n}\r\n \r\n.login-page-main-content-section {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n}\r\n \r\n.login-page-main-content-section>div:nth-child(2) {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0px;\r\n    color: #666666;\r\n}\r\n \r\n.login-page-main-content-section>div:nth-child(3) {\r\n    font: normal normal normal 26px/30px Lato;\r\n    letter-spacing: 0px;\r\n    margin-bottom: 20px;\r\n    color: #333333;\r\n}\r\n \r\n.login-page-btn {\r\n    min-height: 56px;\r\n}\r\n \r\n \r\n.login-page-msg-under-line {\r\n    height: 4px;\r\n    width: 10%;\r\n    background: #FF9700 0% 0% no-repeat padding-box;\r\n    border-radius: 6px;\r\n}\r\n \r\n.footer-start-section-login{\r\n    position: absolute !important;\r\n    top: 100% !important;\r\n}\r\n \r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --login-content-height: 100%;\r\n        --login-content-border-radius: 0;\r\n    }\r\n \r\n    .login-page-starter-section {\r\n        width: 100%;\r\n        height: 100vh;\r\n        background-color: var(--bg-blue);\r\n        overflow: hidden;\r\n        position: fixed;\r\n        z-index: -1;\r\n    }\r\n    .login-page-content-section {\r\n        max-width: 100%;\r\n        flex: 100%;\r\n    }\r\n \r\n    /* .login-page-content-section>div:first-child {\r\n        display: none;\r\n    } */\r\n \r\n    /* .login-page-content-section>.col-md-6:first-child {\r\n        max-width: 0;\r\n        flex: 0;\r\n    } */\r\n \r\n    .login-page-content-section>div:nth-child(1) {\r\n        padding-right: 0 !important;\r\n        min-height: 100vh;\r\n        width: 100%;\r\n        max-width: 100%;\r\n        flex: 0 0 100%;\r\n    }\r\n \r\n    .login-page-main-content-section {\r\n        min-height: 100vh;\r\n        justify-content: center;\r\n    }\r\n \r\n    .login-page-main-content-section>div:nth-child(3) {\r\n        font: normal normal normal 26px/30px Lato;\r\n        text-align: center;\r\n        padding: 0 7px;\r\n        font: normal normal bold 26px/32px Lato;\r\n    }\r\n \r\n    .login-page-main-content-section .login-page-logo {\r\n        /* position: absolute; */\r\n        top: 10px;\r\n    }\r\n \r\n    .login-page-main-content-section .celcom-default-btn.login-page-btn {\r\n     /* position: absolute;  */\r\n        bottom: 50px;\r\n        max-width: 50%;\r\n        margin-top: 50px;\r\n        min-height:50px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
